import React from 'react'
import styled from 'styled-components'
import { IconContext } from "react-icons";
import { FiMapPin } from "react-icons/fi";
import ContactForm from '../../molecules/ContactForm'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-left: 2rem;
  margin-right: 2em;
`

const ContactWrapper = styled.div`
  margin-top: 20px;
  @media (min-width: 1024px) {
    margin-top: 80px;
  }
`

const FormWrapper = styled.div`
  margin-top: auto;
  margin-bottom: 20px;
  @media (min-width: 1024px) {
    margin-bottom: 80px;
  }
`

const H3 = styled.h3`
  text-transform: uppercase;
`

const H5 = styled.h5`
  display: inline-block;
  vertical-align: middle;
`

class ContactUs extends React.Component {
  render() {
    return(
      <IconContext.Provider key="scroll" value={{ color: "white", className: "location-icon", size: "1.5em" }}>
        <Container>
          <ContactWrapper>
            <H3 className="text-white font-mono mb-2 lg:mb-5 text-base lg:text-2xl">Contact us</H3>
            <p className="text-sm text-white font-mono mb-2 lg:mb-5 hidden lg:block">
              If you have an idea, need support, looking for a collaboration or simply have a beer!
            </p>
          </ContactWrapper>

          <FormWrapper>
            <ContactForm/>
          </FormWrapper>
        </Container>
      </IconContext.Provider>
    )
  }
}

export default ContactUs
